<template>
  <div class="page_content">
    <div class="page_content_top">
      <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" :buttonFlag="false"></v-button>
      <div class="page_content_top_line">
        <v-search v-if="formList.drugGyycshAuditList.length > 0" :searchList="formList.drugGyycshAuditList" :getRequestData="getRequestData" @searchData="searchData" @openSearchs="openSearch"></v-search>
      </div>
    </div>
    <div class="page_content_center">
      <el-table size="mini" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row>
        <el-table-column align="center" label="选择操作" width="80">
          <template slot-scope="scope">
            <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
              <i class="el-icon-thumb"></i>
            </el-radio>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="ownbillno" label="易明订单号" show-overflow-tooltip min-width="120"></el-table-column>
        <el-table-column align="center" prop="uom" label="单位" show-overflow-tooltip min-width="120"></el-table-column>
        <el-table-column align="center" prop="supplier" label="供应商" show-overflow-tooltip min-width="120"></el-table-column>
        <el-table-column align="center" prop="drugname" label="商品名" show-overflow-tooltip min-width="120"></el-table-column>
        <el-table-column align="center" prop="spec" label="规格" show-overflow-tooltip min-width="120"></el-table-column>
        <el-table-column align="center" prop="producer" label="生产厂家" show-overflow-tooltip min-width="120"></el-table-column>
        <el-table-column align="center" prop="lotno" label="批号" show-overflow-tooltip min-width="120"></el-table-column>
        <el-table-column align="center" prop="enddate" label="效期" show-overflow-tooltip min-width="120"></el-table-column>
        <el-table-column align="center" prop="rejHn" label="产生环节" show-overflow-tooltip min-width="120"></el-table-column>
        <el-table-column align="center" prop="proc" label="控制措施" show-overflow-tooltip min-width="120"></el-table-column>
        <el-table-column align="center" prop="rejInfo" label="具体问题描述" show-overflow-tooltip min-width="120"></el-table-column>
        <el-table-column align="center" prop="rejQty" label="问题品种数量" show-overflow-tooltip min-width="120"></el-table-column>
        <el-table-column align="center" prop="asnQty" label="到货数量" show-overflow-tooltip min-width="120"></el-table-column>
        <el-table-column align="center" prop="aud1username" label="审批人1姓名" show-overflow-tooltip min-width="120"></el-table-column>
        <el-table-column align="center" prop="aud1remark" label="审批人1意见" show-overflow-tooltip min-width="120"></el-table-column>
        <el-table-column align="center" prop="aud2username" label="审批人2姓名" show-overflow-tooltip min-width="120"></el-table-column>
        <!-- <el-table-column align="center" prop="aud2remark" label="审批人2审批备注" show-overflow-tooltip min-width="120"></el-table-column> -->
        <el-table-column align="center" prop="createusername" label="发起人姓名" show-overflow-tooltip min-width="120"></el-table-column>
        <el-table-column align="center" prop="auditorCn" label="质量审核人" show-overflow-tooltip min-width="120"></el-table-column>
        <el-table-column align="center" prop="auditComment" label="质量审核意见" show-overflow-tooltip min-width="120"></el-table-column>
        <el-table-column align="center" prop="state" label="状态" show-overflow-tooltip min-width="100">
          <template slot-scope="scope">
            <el-tag size="mini" type="primary">{{scope.row.state == 0 ? '待审批' : '已审批'}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="cust1" label="备用1" show-overflow-tooltip min-width="100"></el-table-column>
        <el-table-column align="center" prop="cust2" label="备用2" show-overflow-tooltip min-width="100"></el-table-column>
        <el-table-column align="center" prop="cust3" label="备用3" show-overflow-tooltip min-width="100"></el-table-column>
        <el-table-column align="center" prop="cust4" label="备用4" show-overflow-tooltip min-width="100"></el-table-column>
        <el-table-column align="center" prop="cust5" label="备用5" show-overflow-tooltip min-width="100"></el-table-column>
      </el-table>
    </div>
    <div class="page_content_bottom">
      <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
    </div>
    <el-dialog :title="titleInfo" center :visible.sync="audioBox" append-to-body>
      <el-form :model="sendDataInfo" label-position="top">
        <el-row :gutter="20" style="margin: 15px 0;">
            <el-col :span="12">
            <div style="display: flex; align-items: center;">
              <span style="width: 100px; text-align: right; margin-right: 10px;">审核订单号：</span>
              <el-input size="mini" v-model="sendDataInfo.auditbillno" readonly style="flex: 1;"></el-input>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin: 15px 0;">
          <el-col :span="12">
            <div style="display: flex; align-items: center;">
              <span style="width: 100px; text-align: right; margin-right: 10px;">审批时间：</span>
              <el-date-picker v-model="sendDataInfo.audittime" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" size="mini" readonly style="flex: 1;">
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="12">
            <div style="display: flex; align-items: center;">
              <span style="width: 60px; text-align: right; margin-right: 10px;">审批人：</span>
              <el-input size="mini" v-model="sendDataInfo.auditorcn" readonly style="flex: 1;"></el-input>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin: 15px 0;">
          <el-col :span="24">
            <div style="display: flex; align-items: flex-start;">
              <el-input type="textarea" placeholder="请输入内容" v-model="sendDataInfo.auditcomment" maxlength="200" show-word-limit style="flex: 1;" :rows="4">
              </el-input>
            </div>
          </el-col>
        </el-row>
        <el-form-item label="">
          <el-radio-group v-model="sendDataInfo.auditstatus">
            <el-radio-button :label="'audit_pass'">审批通过</el-radio-button>
            <el-radio-button :label="'audit_reject'">审批不通过</el-radio-button>
            <el-radio-button :label="'audit_delete'">作废</el-radio-button>
          </el-radio-group>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="audioBox = false">取 消</el-button>
        <el-button type="primary" @click="submitDJAction()">登 记</el-button>
      </div>
    </el-dialog>

    <!-- 审批记录弹窗 -->
    <el-dialog title="审批记录" :visible.sync="auditRecordBox" width="80%" append-to-body>
      <el-table :data="auditRecordList" v-loading="auditRecordLoading" border stripe style="width: 100%">
        <el-table-column prop="auditbillno" label="审批单号" width="180" align="center"></el-table-column>
        <el-table-column prop="auditorcn" label="审批人" width="100" align="center"></el-table-column>
        <el-table-column prop="auditstatus" label="审批状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag size="mini" type="primary">
              {{ scope.row.auditstatus == 'audit_pass' ? '审批通过' : scope.row.auditstatus == 'audit_reject'
                                ?
                                '审批不通过' : '作废' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="auditcomment" label="审批意见" min-width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="audittime" label="审批时间" width="150" align="center">
          <template slot-scope="scope">
            {{ scope.row.audittime }}
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="auditRecordBox = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import formList from "./drug";
import SearchScheme from "../../byComponents/SearchScheme.vue";
export default {
  name: "gybhgAuditList",
  //import引入的组件需要注入到对象中才能使用
  components: { SearchScheme },
  data() {
    //这里存放数据
    return {
      tableHeight: 0,
      getRequestData: {
        audittasknumber: "", //任务号
        batchnbr: "", //批号
        itemname: "", //商品名称
        page: 1,
        rows: 30,
        start: "",
        end: "",
        state: "", //审批状态
        createrName: "",
        startStr: "",
        endStr: "",
      },
      returnData: {
        pages: 0, // 总页数
        total: 0, // 总条数
        pageNum: 0, // 当前页数
        list: [],
      },
      buttonList: [],
      selectedDataIndex: 0,
      showStatus: false,
      actionData: {},
      formList: formList,
      DialogVisible: false,
      seId: "",
      seTitle: "",
      seWidth: "",
      parentSearchData: {},
      sField: "",
      // 审核登记
      titleInfo: '审核登记',
      audioBox: false,
      sendDataInfo: {
        auditstatus: 'audit_pass',
        audittime: '',
        auditorcn: '',
        auditcomment: '',
        auditbillno: '',
      },
      // 审批记录弹窗
      auditRecordBox: false,
      auditRecordList: [],
      auditRecordLoading: false,

    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    "getRequestData.gchmType": {
      handler: function (newValue, oldValue) {
        this.searchData();
      },
      deep: true,
    },
  },
  //方法集合
  methods: {

    // 格式化审批时间 - 传参用（yyyy-MM-dd HH:mm:ss格式）
    formatAuditTime(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    // 表格切换焦点方法
    tableNextFocus(field, index) {
      console.log(this.drugObj, "测试");

      if (field == "keydown") {
        return;
      }
      this.$nextTick(() => {
        if (this.$refs[field][index]) {
          this.$refs[field][index].focus();
        } else {
          this.$refs[field].focus();
        }
      });
    },


    // 点击穿透字段 传参单号
    toDetail(orderId) {
      if (orderId) {
        // 设置为true 打开穿透组件首页
        var isPenetrate = true;
        // 设置缓存 存入点击单号
        this.resetSetItem("penetrateOrderId", orderId);
        // 与父级跨域通信 传递isPenetrate参数
        window.parent.postMessage(
          {
            //向窗口发送MessageEvent消息
            cmd: "returnFormJson",
            params: { isPenetrate }, //参数
          },
          "*"
        );
      }
    },
    getSeWidth(e) {
      this.seWidth = e + "%";
    },
    getSearchName(e) {
      this.seTitle = e;
    },
    // 检索Id, 索引(表格中), 标识ppamId
    openSearch(sId, index, type, sField, tableType) {
      this.DialogVisible = true;
      this.tableType = tableType;
      this.seId = sId;
      this.seIndex = index;
      this.seType = type;
      this.sField = sField;
      this.parentSearchData[type] = this.getRequestData[type];
    },
    changeInputModel(val) {
      if (val != "" || val != undefined) {
        this.DialogVisible = false;
        this.paramValue(val);
      }
    },
    // 赋值字段
    paramValue(val) {
      let arr = this.sField.split(",");
      arr.forEach((item) => {
        if (this.tableType == "hydetails") {
          this.selectedDetailsIndex = this.seIndex;
          this.drugObj[this.tableType][this.selectedDetailsIndex][item] =
            val[item];
        } else {
          this.getRequestData[item] = val[item];
        }
      });
      if (this.tableType == "hydetails") {
        this.tableNextFocus("batchno", this.seIndex);
      }
    },
    // 子组件触发
    drawerCancel(commitData) {
      this.showStatus = false;
      commitData && this.getDataList();
    },
    getPageInfo() {
      this.getDataList();
    },

    // 动作集合
    actionSet(actionData) {
      console.log(actionData.actionType, "actionData.actionType");

      switch (actionData.actionType) {
        case 0:
          if (!this.returnData.list[this.selectedDataIndex]) {
            this.$message({
              message: "请先选择您要操作的数据",
              type: "error",
            });
            return false;
          }
          // 检查数据状态，如果已审核则不允许再次审核
          if (this.returnData.list[this.selectedDataIndex].state == 1) {
            this.$message({
              message: "该数据已审核，不能重复审核",
              type: "warning",
            });
            return false;
          }
          this.sendDataInfo.auditbillno=this.returnData.list[this.selectedDataIndex].ownbillno
          this.audioBox = true
          break;
        case 1:
          if (!this.returnData.list[this.selectedDataIndex]) {
            this.$message({
              message: "请先选择您要操作的数据",
              type: "error",
            });
            return false;
          }
          this.openAuditRecordDialog();
          break;

      }
    },
    // 审核登记
    async submitDJAction() {
      try {
        // 确保审批时间格式正确（yyyyMMdd HHmmss）
        let auditTimeFormatted = this.sendDataInfo.audittime;
        if (this.sendDataInfo.audittime instanceof Date) {
          auditTimeFormatted = this.formatAuditTime(this.sendDataInfo.audittime);
        } else if (typeof this.sendDataInfo.audittime === 'string' && this.sendDataInfo.audittime.includes('-')) {
          // 如果是 yyyy-MM-dd HH:mm:ss 格式，转换为 Date 对象再格式化
          auditTimeFormatted = this.formatAuditTime(new Date(this.sendDataInfo.audittime));
        }

        const responseData = await this.$http.gyycshAudit(
          {
            auditbillno: this.sendDataInfo.auditbillno,
            auditcomment: this.sendDataInfo.auditcomment,
            auditorcn: this.sendDataInfo.auditorcn,
            auditstatus: this.sendDataInfo.auditstatus,
            audittime: auditTimeFormatted,
            state: this.returnData.list[this.selectedDataIndex].state,
            id: this.returnData.list[this.selectedDataIndex].id,
          }
        )
        console.log(responseData, 'responseData');

        if (responseData.status == 200) {
          this.$message({
            message: "审核登记成功",
            type: "success",
          })
          this.audioBox = false
          this.searchData();
        } else {
          this.$message({
            message: responseData.message,
            type: "error",
          })
        }
      } catch (error) {
        this.$message({
          message: "操作失败",
          type: "error",
        })
      }
    },
    // 打开审批记录弹窗
    openAuditRecordDialog() {
      this.auditRecordBox = true;
      this.getAuditRecordList();
    },
    // 获取审批记录列表
    async getAuditRecordList() {
      this.auditRecordLoading = true;
      try {


        // 模拟数据，实际应该调用API
        let responseData = await this.$http.gyycshQuerySp({ ids: [this.returnData.list[this.selectedDataIndex].ownbillno] });

        console.log(responseData, 'responseData');
        if (responseData.status == 200) {
          this.auditRecordList = responseData.result
        } else {
          this.$message({
            message: responseData.message,
            type: "error",
          })
        }

      } catch (error) {
        console.error('获取审批记录失败:', error);
        this.$message.error('获取审批记录失败');
      } finally {
        this.auditRecordLoading = false;
      }
    },
    // 数据搜索
    searchData() {
      this.getRequestData.page = 1;
      this.getDataList();
    },
    // 数据翻页
    setDataPageNumber(val) {
      this.getRequestData.page = val;
      this.getDataList();
    },

    // 切换显示条数
    setDataPageSize(val) {
      this.getRequestData.page = 1;
      this.getRequestData.rows = val;
      this.getDataList();
    },

    // 获取数据列表
    async getDataList() {
      let responseData = await this.$http.gyycshQuery(this.getRequestData);
      if (responseData.status == 200) {
        this.returnData.list = responseData.result.list;
        this.returnData.pages = responseData.result.pages;
        this.returnData.total = responseData.result.total;
        this.returnData.pageNum = responseData.result.pageNum;
        this.selectedDataIndex = 0;
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },
    async getButtonList() {
      this.buttonList = await this.$common.getActionButton();
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    var objs = this.$common.getSearchData(
      this.formList.drugGyycshAuditList,
      "page",
      "rows",
      30
    );
    for (const key in objs) {
      this.$set(this.getRequestData, key, objs[key]);
    }
    var info = sessionStorage.getItem("userInfo");
    console.log(JSON.parse(info), 'info');
    this.sendDataInfo.auditorcn = JSON.parse(info).opmName;
    this.sendDataInfo.auditorid = JSON.parse(info).opmId;
    this.getDataList();
    this.getButtonList();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    // 初始化审批时间为当前本地时间
    this.sendDataInfo.audittime = this.formatAuditTime(new Date());
  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() {
    this.tableHeight = this.$common.getTableHeight();
  }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
ul {
  list-style: none;
}

.box {
  padding: 10px;
}

.space_between {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.align_items_center {
  display: flex;
  align-items: center;
}

.align_items_start {
  display: flex;
}

.marginTop {
  margin-top: 5px;
}

.box_center {
  border: 1px solid #000;
  margin-top: 5px;
}

.ul {
  display: flex;
}

.ul_li {
  width: calc(100vw / 6);
}

.ul_li1 {
  width: calc(100vw / 3);
}

.ul_li2 {
  width: calc(100vw / 2);
  border-top: 1px solid #000;
}

.ul_li3 {
  width: 100vw;
  border-top: 1px solid #000;
}

.ul_li4 {
  width: 100vw;
}

.ul_li5 {
  border-top: 1px solid #000;
}

.ul .li {
  text-align: center;
  padding: 5px;
  border-right: 1px solid #000;
  border-bottom: 1px solid #000;
}

.ul .ul_li6 {
  border-bottom: none;
}

.ul .li:last-child {
  border-right: none;
}

.li_title {
  flex-shrink: 0;
}

.table {
  border-top: 1px solid #000;
}

.table .btn {
  margin-bottom: 5px;
}

::v-deep .el-radio {
  margin-right: 10px;
}

::v-deep .el-radio__label {
  padding-left: 5px;
}

::v-deep .el-checkbox {
  margin-right: 10px;
}

::v-deep .el-checkbox__label {
  padding-left: 5px;
}

/* .input ::v-deep .el-input__inner{
      border: none;
      border-radius: 0;
      border-bottom: 1px solid #000;
  }
  .input ::v-deep .el-input__inner:focus{
      border-bottom: 1px solid #409EFF;
  } */
.floor {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>